import { InputAdapterService } from '@api/services/input-adapter/input-adapter.service';
import { Injectable } from '@angular/core';
import {
  ApiParams,
  ApiParamsAlterate,
  QuotationParamsDTO
} from '@core/modules/api/models';

@Injectable({
  providedIn: 'root'
})
export class InputAdapterCustomService extends InputAdapterService {
  constructor() {
    super();
  }

  putPositionQuotation(
    params: ApiParams<{ positionId: string }, QuotationParamsDTO>
  ): ApiParamsAlterate<{ positionId: string }> {
    return {
      ...params,
      body: {
        tuplaId: params.body.id,
        rata: params.body.installment,
        tan: params.body.tan,
        durata: params.body.duration,
        tabellaFinanziaria: params.body.financialTable,
        massimoNettoFinanziabile: params.body.amount
      }
    };
  }
}
